import { render, staticRenderFns } from "./GoalIcon.vue?vue&type=template&id=487b5e63&scoped=true&lang=pug"
import script from "./GoalIcon.vue?vue&type=script&lang=js"
export * from "./GoalIcon.vue?vue&type=script&lang=js"
import style0 from "./GoalIcon.vue?vue&type=style&index=0&id=487b5e63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487b5e63",
  null
  
)

export default component.exports